import { Agente } from './agente.class';
import { Delegacion } from './delegacion.class';
import * as msg from '../../../assets/msg/message.json';


export class Delegado extends Agente {


    delegaciones: Delegacion[];

    constructor() {
        super();
    }


    public getRestriccionSeleccionAgente() {
        return (<any>msg).msgHome.seleccioneDelegacion;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/agente/delegado.class.ts